import Repository from "./Repository";

const administration = "/administration";

export default {
  createClass: (payload) =>
    Repository.post(`${administration}/create_class/`, payload, {
      timeout: 720000,
    }),
  annualPurge: () => Repository.delete(`${administration}/annual_purge/`),
  downloadReport: (filename) =>
    Repository.post(`${administration}/download_report/`, {
      filename: filename,
    }),
};
